


















































































import { Vue, Component, Mixins, Prop } from 'vue-property-decorator'
import { AA } from '@/lib/mixin'
import { AbsCatalog, Catalog } from '@/shared/catalog.model'
import { aplusButtonClick } from '../lib/qtLIb'

@Component
export default class Grid extends Mixins(Vue, AA) {
  @Prop(Number) readonly activeNav!: number

  serviceEmptyArticle?: Article

  get categories(): Array<AbsCatalog> {
    return this.$store.getters.catalogs
  }

  get items(): Array<AbsCatalog> {
    if (this.categories && this.categories.length > this.activeNav) {
      return this.categories[this.activeNav].catalogs || []
    } else {
      return []
    }
  }

  get starHonour(): AbsCatalog {
    // 智能陪练
    return this.getCatalog('star_honour')
  }
  get mgmtCatalog(): AbsCatalog {
    // 管理类培训
    return this.getCatalog('management_training')
  }
  get productCatalog(): AbsCatalog {
    // 产品词条
    return this.getCatalog('product_wiki')
  }
  get saleCatalog(): AbsCatalog {
    // 销售类培训
    return this.getCatalog('sales_training')
  }
  get userCatalog(): AbsCatalog {
    // 客户服务类培训
    return this.getCatalog('customer_service')
  }
  get trainingCatalog(): AbsCatalog {
    // 培训中心
    return this.getCatalog('training_center')
  }
  get vehicleGuidance(): AbsCatalog {
    // 车型操作指南
    return this.getCatalog('vehicle_guidance')
  }

  get funcAndServCatalog(): AbsCatalog {
    // 功能及服务
    return this.getCatalog('functions_services')
  }
  get actionCatalog(): AbsCatalog {
    // 动向捕捉
    return this.getCatalog('trend_catch')
  }
  get expressCatalog(): AbsCatalog {
    // 培训快报
    return this.getCatalog('training_news')
  }
  get eventCatalog(): AbsCatalog {
    // 赛事追踪
    return this.getCatalog('race_track')
  }

  getCatalog(name: string): AbsCatalog {
    return (
      (this.items.find((e) => e.name === name) as AbsCatalog) || new Catalog()
    )
  }

  goto(catalog: AbsCatalog) {
    const eventName =
      this.activeNav === 0 ? 'slhp_button_clk' : 'sehp_tutton_clk'
    aplusButtonClick({
      // eslint-disable-next-line @typescript-eslint/camelcase
      event_name: eventName,
      // eslint-disable-next-line @typescript-eslint/camelcase
      button_name: catalog.title,
    })
    this.$router.push(`/kb/${this.activeNav}/${catalog.id || ''}`)
    this.pageTrack(catalog.title || '')
  }

  ailink(catalog: AbsCatalog) {
    aplusButtonClick({
      // eslint-disable-next-line @typescript-eslint/camelcase
      event_name: this.activeNav === 0 ? 'slhp_button_clk' : 'sehp_tutton_clk',
      // eslint-disable-next-line @typescript-eslint/camelcase
      button_name: catalog.title,
    })
    console.log(catalog.name)
    if (catalog.name === 'star_honour') {
      window.location.href = 'https://mercedes.trainingmaster.cn/login.html'
    } else if (catalog.name === 'product_wiki') {
      window.location.href =
        'http://productwiki.mercedes-benz.com.cn'
    }
  }

  viewHonour() {
    this.pageTrack(this.starHonour.title || '铸星荣耀')
  }

  pageTrack(title: string): void {
    this.tracking({
      isAction: true,
      pageName: `Training_Home_${this.activeNav}`,
      actionName: title,
    })
  }

  launchError(e: Error) {
    console.error('launchError:', e)
  }

  launchSuccess() {
    this.pageTrack(this.starHonour.title || '铸星荣耀')
  }

  hitLaunch(e: Event) {
    console.log('hitLaunch:', e)
  }
}
